var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-button-center"},[_c('span',{staticClass:"is-size-7"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"tool-button",class:{'has-background-primary': _vm.highlight},on:{"click":function($event){return _vm.action()}}},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }